<button (click)="endSession.next()" class="demo-reset" i18n="@@demo.button.end.session">
  Reset Demo
</button>
